import InputSearch from "../../../components/input/InputSearch";
import AdvancedSearch from "../../../profile/components/dialogs/AdvancedSearch";
import { FC, useContext, useEffect, useState } from "react";
import TableCustom from "../../../components/table-custom/TableCustom";
import useMultiLanguage from "../../../../hook/useMultiLanguage";
import { ResignInfo } from "../../models/resignModels";
import { FIELD_SEARCH_RESIGN, RESIGN, listStatusResign } from "../../constants/resignConsts";
import { deleteResign, getListResign } from "../../services/resignServices";
import { toast } from "react-toastify";
import { EXPORT_FILE_NAME, INIT_INPUT_SEARCH, RESPONSE_STATUS_CODE, TYPE } from "../../../constants/moduleConsts";
import { exportThoiViec } from "../../../services/exportFileServices";
import { checkStatus, convertSearch, exportToFile, formatDateTable, hasAuthority, searchDataRoleUser } from "../../../utils/functionUtils";
import { PERMISSIONS, PERMISSION_ABILITY } from "../../../../constants";
import { Col, Row } from "react-bootstrap";
import AppContext from "../../../../AppContext";
import { GroupButton } from "../../../components/GroupButton";
import { IItemSearch } from "../../../models/models";

interface IProps {
  handleOpenDialog: (row: ResignInfo) => void;
  handleOpenAddNewDialog: () => void;
  listResign: ResignInfo[];
  setListResign: React.Dispatch<React.SetStateAction<ResignInfo[]>>;
  initSearchObject?: Object;
  setInitSearchObject?: React.Dispatch<React.SetStateAction<any>>;
  dataChecked: ResignInfo[];
  setDataChecked: React.Dispatch<React.SetStateAction<ResignInfo[]>>;
}

const ResignInformation: FC<IProps> = (props) => {
  const {
    handleOpenDialog,
    handleOpenAddNewDialog,
    listResign,
    setListResign,
    initSearchObject,
    setInitSearchObject,
    dataChecked,
    setDataChecked
  } = props
  const { lang } = useMultiLanguage();
  const { setPageLoading } = useContext(AppContext);

  document.title = `${lang("GENERAL.APP.NAME")} | ${lang("GENERAL.RESIGN")}`;
  const [totalPage, setTotalPage] = useState<number>(0);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [numberOfElements, setNumberOfElements] = useState<number>(0);
  const [searchObject, setSearchObject] = useState<any>(initSearchObject || {});
  const [isAdvancedSearch, setIsAdvancedSearch] = useState<boolean>(false);
  const [listInputSearch, setListInputSearch] = useState<any[]>([INIT_INPUT_SEARCH])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchObject({
      ...searchObject,
      keyword: e.target?.value
    })
  }

  const handleSearch = (data: any = {}) => {
    const dataSearch: any = {
      ...searchObject,
      ...data
    }
    dataSearch.keyword = dataSearch?.keyword?.trim() || ""
    setInitSearchObject && setInitSearchObject(dataSearch);
    updatePageData(dataSearch)
  }

  useEffect(() => {
    if (searchObject?.pageIndex && searchObject?.pageSize) {
      handleSearch()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchObject?.pageIndex, searchObject?.pageSize])

  const handleAdvancedSearch = (data: IItemSearch[]) => {
    setListInputSearch(data)
    handleSearch({ ...convertSearch(data), pageIndex: 1 })
  }

  const handleOpenAdvancedSearch = () => {
    setIsAdvancedSearch(true)
  }

  const updatePageData = async (searchObject?: any) => {
    try {
      setSearchObject({ ...searchObject });
      setPageLoading(true);
      const { data } = await getListResign(hasAuthority(PERMISSIONS.USER, PERMISSION_ABILITY.VIEW) ? searchDataRoleUser(searchObject) : { ...searchObject });
      if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
        setListResign(data?.data?.content || []);
        setTotalPage(data?.data?.pageable?.totalPages || 0);
        setTotalElements(data?.data?.pageable?.totalElements);
        setNumberOfElements(data?.data?.pageable?.numberOfElements);
        setIsAdvancedSearch(false);
      } else {
        toast.warning(data?.message);
      }
    } catch (err: any) {
      toast.error(lang("GENERAL.ERROR"));
    } finally {
      setPageLoading(false);
    }
  };

  const handleDelete = async (ids: string[]) => {
    try {
      const { data } = await deleteResign(ids);
      if (data.code === RESPONSE_STATUS_CODE.SUCCESS) {
        toast.success(lang("TOAST.DELETE.SUCCESS"));
        await updatePageData(searchObject);
        return true;
      } else {
        toast.warning(data?.message);
      }
    } catch (error) {
      toast.error(lang("GENERAL.ERROR"));
    }
  }

  const columns = [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: "50px",
        minWidth: "50px"
      },
      render: (row: any, index: number, stt: number) => <span>{stt}</span>
    },
    {
      name: lang('RESIGN.STATUS'),
      field: "trangThai",
      headerStyle: {
        width: "150px",
        minWidth: "150px"
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any) => (
        <span className={`${checkStatus(listStatusResign, row?.trangThai?.code)} status`}>
          {row?.trangThai?.name}
        </span>
      )
    },
    {
      name: lang('RESIGN.EMPLOYEECODE'),
      field: "maNhanVien",
      headerStyle: {
        width: "120px",
        minWidth: "120px"
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any) => <span className="color-steel-blue fw-600">{row?.maNhanVien}</span>
    },
    {
      name: lang('GENERAL.FULLNAME'),
      field: "fullName",
      headerStyle: {
        width: "200px",
        minWidth: "200px"
      },
      cellStyle: {
        textAlign: "left",
      },
    },
    {
      name: lang('INPUT.SALARY.DEPARTMENT'),
      field: "phongBanText",
      headerStyle: {
        minWidth: "200px"
      },
      cellStyle: {
        textAlign: "left",
      },
    },
    {
      name: lang('GENERAL.EMPLOYEE.POSITION'),
      field: "chucVuText",
      headerStyle: {
        minWidth: "220px"
      },
      cellStyle: {
        textAlign: "left",
      },
    },
    {
      name: lang('GENERAL.EMPLOYEE.TITLE'),
      field: "viTriCongViecText",
      headerStyle: {
        minWidth: "270px"
      },
      cellStyle: {
        textAlign: "left",
      },
    },
    {
      name: lang('RESIGN.TYPE'),
      field: "loaiThoiViec",
      headerStyle: {
        minWidth: "200px"
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row?.loaiThoiViec?.name
    },
    {
      name: lang('RESIGN.DATE'),
      field: "ngayHieuLuc",
      headerStyle: {
        minWidth: "110px"
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any) => <span>{formatDateTable(row?.ngayHieuLuc)}</span>
    },
    {
      name: lang('INPUT.WORKPROCESS.DECISION.NUMBER'),
      field: "soQuyetDinh",
      headerStyle: {
        minWidth: "150px"
      },
      cellStyle: {
        textAlign: "enter",
      },
    }
  ];

  return (
    <div className="spaces px-10 py-16">
      <Row className="spaces mb-8 flex-middle ml-10">
        <Col xs={4} xxl={6} className="spaces p-0">
          <h2 className="breadcrumb-title">Danh sách thôi việc</h2>
        </Col>
        <Col xs={8} xxl={6} className="flex">
          <div className="spaces mr-10 flex-1">
            <InputSearch
              className='border-3px'
              value={searchObject?.keyword}
              placeholder="Tìm kiếm theo mã NV, họ và tên, phòng ban, chức vụ và chức danh"
              isEnter={true}
              handleSearch={() => handleSearch({ pageIndex: 1 })}
              handleChange={handleChange}
            />
          </div>
          <GroupButton className="spaces mr-10" handleEvent={() => handleSearch({ pageIndex: 1 })}>
            {lang("BTN.SEARCH")}
          </GroupButton>
          <GroupButton outline handleEvent={handleOpenAdvancedSearch}>
            {lang("BTN.ADVANCE_SEARCH")}
          </GroupButton>
          {isAdvancedSearch &&
            <AdvancedSearch
              open={isAdvancedSearch}
              listInputSearch={listInputSearch}
              handleSearch={handleAdvancedSearch}
              listOption={FIELD_SEARCH_RESIGN}
              handleClose={() => setIsAdvancedSearch(false)}
            />
          }
        </Col>
      </Row>
      <div className="spaces flex-1 pb-18 table-custom">
        <TableCustom
          id="listResign"
          data={listResign}
          columns={columns}
          searchObject={searchObject}
          setSearchObject={setSearchObject}
          buttonAdd={hasAuthority(PERMISSIONS.NGHI_VIEC, PERMISSION_ABILITY.CREATE)}
          buttonExportExcel={!hasAuthority(PERMISSIONS.USER, PERMISSION_ABILITY.VIEW)}
          notDelete={!hasAuthority(PERMISSIONS.NGHI_VIEC, PERMISSION_ABILITY.DELETE)}
          handleExportExcel={(ids: string[]) =>
            exportToFile({
              exportAPI: () => exportThoiViec({ ids, ...searchObject }),
              fileName: EXPORT_FILE_NAME.NGHI_VIEC,
              setPageLoading
            })
          }
          type={TYPE.MULTILINE}
          fixedColumnsCount={4}
          totalPages={totalPage}
          totalElements={totalElements}
          numberOfElements={numberOfElements}
          handleOpenDialog={handleOpenAddNewDialog}
          handleDoubleClick={handleOpenDialog}
          handleDelete={(ids: string[]) => handleDelete(ids)}
          setDataChecked={setDataChecked}
          dataChecked={dataChecked}
          deleteConditional={[{
            keyPath: "trangThai.code",
            value: RESIGN.STATUS.FINISH
          }, {
            keyPath: "raQuyetDinh",
            value: true
          }]}
        />
      </div>
    </div>
  );
}

export default ResignInformation;